module.exports = __webpack_public_path__ + "img/exhaustPipe-1.fab9fdcd.jpg";